module.exports = __webpack_public_path__ + "img/zeus.ee8d4aeb.svg";